// Taşeron portalı — giriş noktası.
//
// Açılış sırası: (1) self-host font (Latin Extended-A: TR + DE), (2) i18n init
// (backend dil paketi + uygulama microcopy'si) TAMAMLANMADAN route render EDİLMEZ
// → ham i18n anahtarı ekrana sızmaz ([[feedback_i18n_key_runtime_path]]).

// IBM Plex Sans 400+600 (S37 Carbon) — Latin + Latin Extended-A tek dosyada: TR ş/ğ/ı/İ + DE ä/ö/ü/ß.
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/600.css';
import './index.css';

import {
  configureApiBaseUrl,
  configureAuthStorage,
  configureCultureStorage,
  hydrateAuthStore,
  i18next,
  initI18n,
  webIdbAuthStorage,
  webLocalCultureStorage,
} from '@isgportal/shared';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { appResources } from './i18n/locales';
import { queryClient } from './lib/queryClient';
import { router } from './router';

async function bootstrap() {
  // Platform enjeksiyonu (herhangi bir istekten/hydrate'ten ÖNCE): web idb +
  // localStorage adaptörleri + config-driven API taban adresi (Vite env).
  configureApiBaseUrl(import.meta.env.VITE_API_BASE_URL);
  configureAuthStorage(webIdbAuthStorage);
  configureCultureStorage(webLocalCultureStorage);
  await hydrateAuthStore();

  await initI18n(appResources);

  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Kök öğe (#root) bulunamadı.');
  }

  createRoot(container).render(
    <StrictMode>
      <I18nextProvider i18n={i18next}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </I18nextProvider>
    </StrictMode>,
  );
}

void bootstrap();
